<template>
  <div class="search-box">
    <div class="search-input-box">
      <van-icon name="arrow-left" size="25" @click="leftBut" />
      <van-field
        class="search-input"
        v-model="searchValue"
        clearable
        placeholder="输入搜索内容"
      />
      <span class="search-btn" @click="toSearch">搜索</span>
    </div>
    <div class="search-history">
      <h3>搜索历史</h3>
      <van-icon name="delete-o" size="19" @click="clearHistory" />
    </div>
    <ul class="search-history-list">
      <li
        class="history-list-item"
        v-for="(item, index) in historyList"
        :key="index"
        @click="historySearch(item)"
      >
        {{ item }}
      </li>
    </ul>
    <ul class="search-advertisement">
      <li
        :class="[
          'search-advertisement-item',
          (index + 1) % 2 === 0 ? 'search-advertisement-item-orgin' : '',
        ]"
        v-for="(item, index) in newsList"
        :key="item.label"
      >
        <h3 class="search-advertisement-title">{{ item.label }}</h3>
        <ul class="advertisement-list">
          <li
            class="advertisement-list-item"
            v-for="(i, idx) in item.list"
            :key="i.artId"
            @click="toDetail(item.label, i.artId)"
          >
            <span
              :class="[
                'number',
                idx === 0 ? 'first' : '',
                idx === 1 ? 'second' : '',
                idx === 2 ? 'third' : '',
              ]"
              >{{ idx + 1 }}</span
            >
            <div class="title" v-html="i.title"></div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import { Icon, Field, Dialog } from "vant";
export default {
  components: {
    "van-icon": Icon,
    "van-field": Field,
  },
  data() {
    return {
      searchValue: "",
      historyList: JSON.parse(localStorage.getItem("recentSearch")) || [],
      newsList: [
        {
          label: "最新资讯",
          list: [],
        },
        {
          label: "最新文献",
          list: [],
        },
        {
          label: "最新综述",
          list: [],
        },
        {
          label: "最新专著",
          list: [],
        },
      ],
    };
  },
  created() {
    this.getNews();
  },
  methods: {
    // 左侧按钮(gubeit为协商的方法名)
    leftBut() {
      window.history.go(-1);
    },
    // 清除搜索历史
    clearHistory() {
      Dialog.confirm({
        title: "温馨提示",
        message: "是否清除搜索历史记录!",
      })
        .then(() => {
          localStorage.removeItem("recentSearch"); // 清除localStorage中的最新搜索
          this.historyList = []; // 清除最新搜索
        })
        .catch(() => {});
    },
    // 进入搜索结果页
    toSearch() {
      if (this.searchValue == "") return; //如果没有关键字则不跳转
      // this.searchTypes();
      this.$router.push({
        //跳转路由并携带参数
        name: "SearchResult",
        query: {
          paramStr: this.searchValue, // 传关键字
        },
      });
      this.recentSearch(this.searchValue); // 调用该方法存储搜索的内容
    },
    // 历史记录点击跳转搜索
    historySearch(value) {
      this.searchValue = value;
      this.toSearch();
    },
    // 累加存储(最近搜索)
    recentSearch(data) {
      const list = JSON.parse(localStorage.getItem("recentSearch")) || []; // 先取出
      if (list.indexOf(data) !== -1) return;
      if (list.length >= 10) {
        // 最多15个,超出将最后一个删除,在第一个位置添加新内容
        list.splice(list.length - 1, 1);
        list.unshift(data);
      } else {
        list.unshift(data); // 将要累加的数据push进数组中
      }
      localStorage.setItem("recentSearch", JSON.stringify(list)); // 将取出的内容再次存储
    },
    // 获取最新信息
    async getNews() {
      for (let index = 1; index <= 4; index++) {
        const res = await this.$apis.searchServe.getLatestNews({ type: index });
        this.newsList[index - 1].list = [...res.data];
      }
    },
    toDetail(type, id) {
      switch (type) {
        case "最新资讯":
          this.$router.push({
            path: "msgDetails",
            query: { type: 5, id },
          });
          break;
        case "最新文献":
          this.$router.push({
            path: "thesisDetail",
            query: { type: 0, id },
          });
          break;
        case "最新综述":
          this.$router.push({
            path: "thesisDetail",
            query: { type: 0, id },
          });
          break;
        case "最新专著":
          this.$router.push({
            path: "concentrationDetails",
            query: { type: 2, id },
          });
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.search-box {
  padding: 0 15px;
  background-color: #fff;
  min-height: 100vh;
  .search-input-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0 5px;
    .search-input {
      padding: 6px 18px;
      width: 274px;
      //   height: 35px;
      background-color: #f5f5f5;
      border-radius: 18px;
    }
    .search-btn {
      font-size: 15px;
      color: #333333;
      line-height: 21px;
    }
  }
  .search-history {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 18px;
    // padding: 0 15px;
    h3 {
      font-size: 17px;
      color: #333333;
      line-height: 24px;
    }
  }
  .search-history-list {
    margin-top: 14px;
    .history-list-item {
      display: inline-block;
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 6px 12px;
      max-width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      background-color: #f5f5f5;
      border-radius: 15px;
    }
  }
  .search-advertisement {
    margin-top: 25px;
    width: 100%;
    display: flex;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
    .search-advertisement-item {
      margin-right: 12px;
      flex-shrink: 0;
      padding: 15px;
      width: 242px;
      background: linear-gradient(180deg, #f0f4fd 0%, #ffffff 100%);
      border-radius: 8px;
      border: 1px solid #397bf9;
      .search-advertisement-title {
        font-size: 15px;
        color: #4a79f1;
        line-height: 21px;
      }
      .advertisement-list {
        margin-top: 19px;
        .advertisement-list-item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 0;
          }
          .number {
            margin-right: 8px;
            width: 14px;
            height: 14px;
            background: #cacaca;
            border-radius: 2px;
            font-size: 10px;
            color: rgba(255, 255, 255, 0.85);
            text-align: center;
            line-height: 14px;
          }
          .first {
            background: #ff3d3d;
          }

          .second {
            background: #fa7614;
          }

          .third {
            background: #faad14;
          }
          .title {
            flex: 1;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
    .search-advertisement-item-orgin {
      background: linear-gradient(180deg, #fff6ea 0%, #ffffff 100%);
      border: 1px solid #faad14;
      .search-advertisement-title {
        color: #fea736;
      }
    }
  }
}
</style>